// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"
import { mountToaster } from "./islands/toaster"
import "./turbo/refresh_dopo_invio"

mountToaster()

// Azione Turbo Stream `redirect`: porta il browser a un altro indirizzo (window.location.href dell'originale,
// es. la pagina del fornitore del pagamento online).
Turbo.StreamActions.redirect = function () {
  window.location.href = this.getAttribute("url")
}
